import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";

import { AgencyService } from "../services/agency.service";
import { AGENCY_LIST_QUERY_KEY } from "../constants/querykeys";
import { BackednResponse } from "@shared/lib/types";
import { Agency } from "@shared/lib/types/agency";

export function useUpdateNote() {
  const {
    mutate: update,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation<
    { note: string; influencerId: string },
    BackednResponse<Agency> | void
  >({
    mutationFn: async ({ note, influencerId }) => {
      return await AgencyService.updateNote(note, influencerId).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      queryKey: AGENCY_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data, { influencerId }) => {
      c.invalidateQueries({
        queryKey: [...AGENCY_LIST_QUERY_KEY, influencerId],
      });
    },
  });

  return {
    update,
    isUpdating,
    isUpdated,
  };
}
